import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CardHeader } from '../../components/CardHeader';
import { FileImportHistoryGrid, FILE_IMPORT_HISTORY_GRID_NAMES } from '../../components/FileImport';
import { OrderStatusCard } from '../../components/OrderStatusCard';
// SERVICES
import { getDashboardCounts } from '../../services';

// Bringing in app version from Package.json
var { version: appVersion } = require('../../../package.json');

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
  },

  orderStatusCardsContainer: {
    flexWrap: 'wrap',
  },
});

const AdminDashboard = withStyles(styles)(props => {
  const { classes } = props;

  const [statusCards, setStatusCards] = useState([
    {
      status: 'Manual Field Rep Assignment Required',
      label: 'Need Manual Assignment',
      count: 0,
      seq: 1,
      territoryBased: true,
    },
    {
      status: 'Field Rep Assigned',
      count: 0,
      seq: 2,
      territoryBased: true,
    },
    {
      status: 'Field Rep Acknowledged',
      label: 'Field Rep Accepted',
      count: 0,
      seq: 3,
      territoryBased: true,
    },
    {
      status: 'Awaiting Assignment to QA',
      label: 'Awaiting QA Assignment',
      count: 0,
      seq: 4,
      territoryBased: false,
    },
    { status: 'QA Assigned', count: 0, seq: 5, territoryBased: false },
    { status: 'QA In Progress', count: 0, seq: 6, territoryBased: false },
    { status: 'Closed', count: 0, seq: 7, territoryBased: false },
  ]);

  useEffect(() => {
    const getCounts = async () => {
      try {
        const data = await getDashboardCounts('ADMIN');
        setStatusCards(data.sort((a, b) => (a.seq > b.seq ? 1 : -1)));
      } catch (error) {
        console.log(error);
      }
    };

    getCounts();
  }, []);

  return (
    <div className={classnames('flex-1', classes.main)}>
      <div className={classnames('row-center-center', 'flex-2')}>
        <div
          className={classnames('flex-1', 'status-cards', 'bg-white', 'align-stretch', 'flex-wrap')}
          style={{ background: 'none', flexDirection: 'row' }}
        >
          {statusCards.map(card => (
            <OrderStatusCard key={card.status} statusInfo={card} />
          ))}
        </div>
      </div>

      <div className={classnames('flex-2', 'mb-10', 'row-center-center')}>
        <div className={classnames('border-left-green', 'card', 'flex-1', 'align-stretch')}>
          <div className={'align-stretch'}>
            <CardHeader label={'Recent Imports'} />
          </div>
          <FileImportHistoryGrid gridName={FILE_IMPORT_HISTORY_GRID_NAMES.DASHBOARD} />
        </div>
      </div>

      <div className={classnames('row-center-center', 'bg-white')} style={{ padding: 10, fontSize: 12, color: '#aaa' }}>
        Admin Portal - Version {appVersion}
      </div>
    </div>
  );
});

AdminDashboard.propTypes = {};

AdminDashboard.defaultProps = {};

export default AdminDashboard;
